export interface DonationCreateOrderPayload {
  scheme_id: number;
  name: string;
  email: string;
  phone: string;
  organization?: string;
  donation_type: string;
  amount: string;
  mode: string;
  payment_mode?: string;
  pan_number?: string;
  message?: string;
  address_line1: string;
  address_line2?: string;
  district: number;
  city: number;
  area: number;
  pincode: string;
  is_head?: boolean;
  is_already_head?: boolean;
  head_phone?: string;
  wants_80g_receipt?: boolean;
  keep_anonymous_on_donor_wall?: boolean;
}

export interface DonationCreateOrderResult {
  order_id: string;
  amount: number;
  currency: string;
  key_id?: string;
  donation_id?: number;
}

export interface DonationVerifyPaymentPayload {
  razorpay_order_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}

export interface DonationVerifyPaymentResult {
  receipt_no?: string;
  message?: string;
}

interface DonationCreateOrderApiResponse {
  message?: string;
  success?: boolean;
  data?: {
    donation_id?: number;
    order_id?: string;
    amount?: number;
    currency?: string;
    key_id?: string;
  };
}

interface DonationVerifyPaymentApiResponse {
  message?: string;
  success?: boolean;
  data?: {
    receipt_no?: string;
    receipt_number?: string;
  };
}

export function parseCreateOrderResponse(
  response: DonationCreateOrderApiResponse | DonationCreateOrderResult
): DonationCreateOrderResult {
  if ("order_id" in response && response.order_id) {
    return {
      order_id: response.order_id,
      amount: response.amount,
      currency: response.currency ?? "INR",
      key_id: response.key_id,
      donation_id: response.donation_id,
    };
  }

  const inner = (response as DonationCreateOrderApiResponse).data;
  return {
    order_id: inner?.order_id ?? "",
    amount: inner?.amount ?? 0,
    currency: inner?.currency ?? "INR",
    key_id: inner?.key_id,
    donation_id: inner?.donation_id,
  };
}

export function parseVerifyPaymentResponse(
  response: DonationVerifyPaymentApiResponse | DonationVerifyPaymentResult
): DonationVerifyPaymentResult {
  if ("receipt_no" in response) {
    return response;
  }
  const inner = (response as DonationVerifyPaymentApiResponse).data;
  return {
    receipt_no: inner?.receipt_no ?? inner?.receipt_number,
    message: (response as DonationVerifyPaymentApiResponse).message,
  };
}
